var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningAltDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Status/Lightning-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8069 1.15498C6.94522 1.21387 7.035 1.34967 7.035 1.50001V4.9991H9C9.13335 4.9991 9.25667 5.06992 9.32389 5.1851C9.3911 5.30027 9.39209 5.44248 9.32649 5.55858L9.08045 5.99401C8.14739 7.64533 6.95745 9.13763 5.55529 10.4149L5.15753 10.7772C5.04775 10.8772 4.8893 10.903 4.75346 10.843C4.61763 10.783 4.53 10.6485 4.53 10.5V7.03058H2.5C2.29289 7.03058 2.125 6.86269 2.125 6.65558C2.125 6.5885 2.14261 6.52553 2.17347 6.47105C3.05286 4.84533 4.17875 3.36559 5.51111 2.08448L6.40008 1.2297C6.50845 1.1255 6.66857 1.09609 6.8069 1.15498ZM3.14229 6.28058H4.905C5.11211 6.28058 5.28 6.44847 5.28 6.65558V9.64727C6.4893 8.50449 7.52584 7.19134 8.3567 5.7491H6.66C6.45289 5.7491 6.285 5.58121 6.285 5.3741V2.38082L6.03094 2.62511C4.90555 3.70721 3.93391 4.93722 3.14229 6.28058Z",
    fill: "#272727"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningAltDark);
export default __webpack_public_path__ + "static/media/lightning-alt-dark.c5786012847f86ab459f1771c02179b4.svg";
export { ForwardRef as ReactComponent };